import React, { Fragment, useContext, useState } from 'react'
import { useFormik } from "formik" ;
import {useNavigate } from "react-router-dom";
import * as Yup from 'yup';

import toast from "react-hot-toast";
import axios from "axios";
import Swal from 'sweetalert2';

import { UserContext } from "../../Context/UserContext.js";
import "./UpdateUserProfile.css" ;






export default function UpdateUserProfile() {
   const navigate = useNavigate() ;
   const [loading , setLoading] = useState(false) ;

   const {setLoggedUser  ,loggedUser , userToken , setUserToken } = useContext(UserContext)


   const header = {
      token:`${process.env.REACT_APP_BEARER_TOKEN} ${userToken || localStorage.getItem("token")}`
   }

   async function submitUpdated(values){
      setLoading(true) ;
      await axios.put(`${process.env.REACT_APP_BASE_URL}/api/v1/users` , values ,  {headers:header} )
      .then(({data})=>{
         if(data.message === "success"){
            setLoading(false) ;
            Swal.fire({
               title:"Successfully"  ,
               text: "Successfully Updated User Information" ,   
               icon: "success"
            });        
            
            localStorage.setItem("token" , data.token)
            setLoggedUser(data.updateUser) ;
            setUserToken(data.token) ;
            navigate("/userProfile") ;
         }
      })
      .catch((error)=>{
         setLoading(false) ;
         toast.error(error.response.data.message)
         Swal.fire({
            title:"Failed Updated"  ,
            text: `Can't Updated User Information Because : ${error.response.data.message}` ,   
            icon: "error"
         });  
      })
   }

   

   let validationSchema = Yup.object({
      name:Yup.string().min(2 , "Name Should be More than 2").max(50 , "Name less than 50").trim() ,
      email:Yup.string().email().trim().optional() ,
      gender: Yup.string().oneOf(['male', 'female'], 'Required Male or Female').required('Gender Required') ,
      phone:Yup.string().matches(/^01[0125][0-9]{8}$/).trim() ,
      birthDay:Yup.string().trim() ,
   })


   let formik = useFormik({
      initialValues:{
         name:loggedUser.name || "" ,
         phone:loggedUser.phone || "" ,
         gender:loggedUser.gender || "" ,
         email:loggedUser.email || "",
         birthDay:"" ,
      } , validationSchema , 
      onSubmit:submitUpdated
   })


   return (
      <Fragment>
         <div className='container updateUserProfile-container'>
            <div className="">
               <h1 className="main-header">تعديل ملفى الشخصى</h1>

               <p className="updateUserProfile-sub-title text-center">يرجى إدخال المعلومات بالطريقة الصحيحة</p>

               <form action="" onSubmit={formik.handleSubmit}>
                  <div className="my-4 position-relative">
                     <i className="fas fa-user icon-input-field"></i>
                     <label htmlFor="name" className="form-label not-required ">إدخل اسم المستخدم </label>
                     <input type="text" 
                        value={formik.values.name}
                        onChange={formik.handleChange} 
                        onBlur={formik.handleBlur}
                        className="form-control " id="name"  
                        name="name" 
                        placeholder="اسم المستخدم" />
                     {
                        formik.errors.name  && formik.touched.name?
                           <div className="text-danger m-0 p-0">{formik.errors.name}</div> 
                           : 
                           <p className="text-success m-0 p-0">Enter Correct Information Please !</p>
                     }
                  </div>


                  <div className="my-4 position-relative">
                     <i className="fa-solid fa-envelope-circle-check icon-input-field"></i>
                     <label htmlFor="email" className="form-label not-required ">أدخل ايميل المستخدم</label>
                     <input type="email" 
                        value={formik.values.email}
                        onChange={formik.handleChange} 
                        onBlur={formik.handleBlur}
                        className="form-control" id="email"  
                        name="email" 
                        placeholder="name@example.com" />
                     {
                     formik.errors.email  && formik.touched.email?
                        <div className="text-danger m-0 p-0">{formik.errors.email}</div> 
                        : 
                        <p className="text-success m-0 p-0">Enter Correct Information Please !</p>
                     }
                  </div>


                  <div className="my-4 position-relative">
                     <i className="fa-solid fa-mobile-screen-button icon-input-field"></i>
                     <label htmlFor="phone" className="form-label not-required">أدخل تليفون المستخدم</label>
                     {/* <input type="tel"  */}
                     <input type="text" 
                        value={formik.values.phone}
                        onChange={formik.handleChange} 
                        onBlur={formik.handleBlur}
                        className="form-control" id="phone"  
                        name="phone" 
                        placeholder="01X XXX XXX XX" />
                     {
                     formik.errors.phone && formik.touched.phone?
                        <div className="text-danger m-0 p-0">{formik.errors.phone}</div> 
                        : 
                        <p className="text-success m-0 p-0">Enter Correct Information Please !</p>
                     }
                  </div>


                  <div className="my-4 position-relative">
                     <i className="fa-solid fa-cake-candles icon-input-field"></i>
                     <label htmlFor="birthDay" className="form-label not-required ">أدخل تاريخ ميلاد المستخدم</label>
                     {/* <input type="tel"  */}
                     <input type="date" 
                        value={formik.values.birthDay}
                        onChange={formik.handleChange} 
                        onBlur={formik.handleBlur}
                        className="form-control" id="birthDay"  
                        name="birthDay" 
                        placeholder="xxxx-xx-xx" />
                     {
                     formik.errors.birthDay && formik.touched.birthDay?
                        <div className="text-danger m-0 p-0">{formik.errors.birthDay}</div> 
                        : 
                        <p className="text-success m-0 p-0">Enter Correct Information Please !</p>
                     }
                  </div>


                  <div className="form-check form-check-inline">
                     <input className="form-check-input" type="radio" 
                        onChange={formik.handleChange} 
                        onBlur={formik.handleBlur}
                        value="male"
                        id="male"
                        name="gender" />
                     <label className="form-check-label" htmlFor="male">ّذكر </label>
                        {formik.errors.gender && formik.touched.gender?<div className="alert alert-danger mt-4 p-2">{formik.errors.gender}</div> :""}
                  </div>


                  <div className="form-check form-check-inline mx-5">
                     <input className="form-check-input" type="radio" 
                        onChange={formik.handleChange} 
                        onBlur={formik.handleBlur}
                        value="female"
                        id="female"
                        name="gender" />
                     <label className="form-check-label" htmlFor="female">أنثى</label>
                        {formik.errors.gender && formik.touched.gender?<div className="alert alert-danger mt-4 p-2">{formik.errors.gender}</div> :""}
                  </div>

                  <div className="d-grid gap-2 col-8 mx-auto">
                     {loading ? 
                           <button className="btn bg-main text-white  mt-2"> <i className="fa-solid fa-spinner fa-spin fa-rotate-180 fa-xl"></i></button>
                        : 
                           <button  type="submit" className="btn bg-main text-white  mt-2">تعديل البيانات</button>
                     }
                  </div>
               </form>
            </div>
         </div>
      </Fragment>
   )
}


